import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Tooltip, ResetViewIcon } from '@frontend/legacy-components';

import { resetView } from 'modules/common/viewer/cadViewer/data/actions';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const ResetViewTool = ({
  isEnabled, // passed in as direct prop
}) => {
  const dispatch = useDispatch();
  const dispatchResetView = useCallback(() => {
    dispatch(resetView());
  }, [dispatch]);
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={<ViewerButtonTooltip firstLine="Reset view" />}
    >
      <ViewerButton aria-label="Reset view" onClick={dispatchResetView}>
        <ResetViewIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default ResetViewTool;
